<template>
  <div id="JH_wrap">
    <div id="JH_in" class="container">
      <div id="JH_width" class="row">
        <Nav></Nav>
        <div class="content2 col-xs-12 col-sm-12 col-md-9" :data-page="'side_' + $route.name">
          <div :class="'m-l-15 raduis-3 ' + [$route.name === 'orderDetail' ? '' : 'background-c-fff']" >
            <router-view/>
          </div>
        </div>
    	</div>
    </div>
    <WLoading ref="loading"></WLoading>
    <ShowPic ref="pic"></ShowPic>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import WLoading from '@/components/Loading'
import ShowPic from '@/components/ShowPic'
export default {
  name: 'app',
  components: {
    Nav,
    WLoading,
    ShowPic
  },
  created () {
		// ?account=xxx&color=ffffff
		this.$store.commit('setEnterpriseId', this.$route.query.account)
		var color = this.$route.query.color || '62a8ea'
		color = color.replace('rgb_', 'rgb(').replace('rgba_', 'rgba(').replace('__', ')').replace(/_/img, ',')
		console.log(color)
		this.$store.commit('setColor', color.indexOf('rgb') > -1 ? color : '#' + color)
		var hidePanel = this.$route.query.hidePanel || ''
		hidePanel = hidePanel !=='' ? hidePanel.split(',') : ''
		console.log(hidePanel)
		this.$store.commit('setHidePanel', hidePanel)
	}
}
</script>

<style>
/* 默认引入阿里云图标 */
@font-face {
  font-family: 'xybicon';  /* project id 249974 */
  src: url('http://at.alicdn.com/t/font_249974_91rj03r2on4gqfr.eot');
  src: url('http://at.alicdn.com/t/font_249974_91rj03r2on4gqfr.eot?#iefix') format('embedded-opentype'),
  url('http://at.alicdn.com/t/font_249974_91rj03r2on4gqfr.woff') format('woff'),
  url('http://at.alicdn.com/t/font_249974_91rj03r2on4gqfr.ttf') format('truetype'),
  url('http://at.alicdn.com/t/font_249974_91rj03r2on4gqfr.svg#xybicon') format('svg');
}
.xybicon {
    font-family:"xybicon" !important;
    font-style:normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;
}
img {
	border:0 none;
}
ul,ol,li {
	list-style:none;
	padding:0;
	margin:0;
}
h1,h2,h3,h4,h5,h6,p {
	margin:0;
	font-weight:normal;
}
a, a:hover, a:active, a:visited, a:focus {
	text-decoration:none;
}
body {
	background:#f2f2f2;
	font-family:"Microsoft Yahei","PingHei","Lucida Grande","Lucida Sans Unicode";
}
#JH_wrap {
	margin:5% 0 0 0;
}
.raduis-3 {
	-moz-border-radius: 3px;
    -khtml-border-radius: 3px;
    -webkit-border-radius: 3px;
    border-radius: 3px;
    -moz-border-radius-bottomleft: 3px;
    -moz-border-radius-bottomright: 3px;
    -khtml-border-radius: 3px;
    -webkit-border-bottom-left-radius: 3px;
    -webkit-border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    overflow:hidden;
}
.background-c-fff {
	background:#fff;
}
.m-r-15 {
	margin-right:15px;
	_margin-right:7px;
}
.m-l-15 {
	margin-left:15px;
	_margin-left:7px;
}
.m-b-5 {
	margin-bottom:5px;
}
.m-b-15 {
	margin-bottom:15px;
}
.padding-15 {
	padding:15px;
}
.padding-20 {
	padding:20px;
}
.padding-30 {
	padding:30px;
}
.padding_t_b_20 {
	padding:20px 0;
}
.h_title {
	font-size:18px;
	line-height:2;
}
@media (min-width: 768px){
	.content1_padding {
		padding:30px;
	}
}
/*侧边菜单*/
.side_menu li a {
	color:#76838f;
	font-size:14px;
	line-height:2.5;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.side_menu li.active_bg a,
.side_menu li a:hover {
	color:#62a8ea;
}
.side_menu #side_menu_btn {
	text-align:center;
	font-size:14px;
	color:#fff;
	line-height:3;
	background:#62a8ea;
}
.side_menu #side_menu_btn i:before {
	content:"\e6e5";
}
.side_menu.open>ul {
	display:block !important;
	width:100%;
	top:115%;
	overflow:hidden;
}
.side_menu.open>ul li a {
	text-align:center;
	animation: slide-left 1s ease both;
    -moz-animation: slide-left 1s ease both;
    -webkit-animation: slide-left 1s ease both;
    -o-animation: slide-left 1s ease both;
    transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.side_menu.open>ul li.active_bg a,
.side_menu.open>ul li a:hover {
	background:#f5f5f5;
}
/*内页布局控制*/
.menber_control .h_title {
	border-bottom:1px solid #eee;
	overflow:hidden;
}
.menber_control .h_title li {
	float:left;
	overflow:hidden;
}
.menber_control .h_title li a {
	display:block;
	float:left;
	font-size:14px;
	line-height:1;
	padding:15px 20px;
	position: relative;
	color:#666;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.menber_control .h_title li a:hover {

}
.menber_control .h_title li a em {
	content:"";
	display:block;
	width:0;
	height:2px;
	background:#eee;
	position:absolute;
	left:50%;
	bottom:0;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.menber_control .h_title li a:hover em{
	width:100%;
	left:0;
}
.menber_control .h_title li.active_bg a {
	color:#62a8ea;
}
.menber_control .h_title li.active_bg a em {
	background:#62a8ea;
	width:100%;
	left:0;
}
.menber_control .order_search {
	border:1px solid #eee;
	padding:5px 36px 5px 20px;
	position:relative;
	-moz-border-radius: 25px;
    -khtml-border-radius: 25px;
    -webkit-border-radius: 25px;
    border-radius: 25px;
    -moz-border-radius-bottomleft: 25px;
    -moz-border-radius-bottomright: 25px;
    -khtml-border-radius: 25px;
    -webkit-border-bottom-left-radius: 25px;
    -webkit-border-bottom-right-radius: 25px;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
}
.menber_control .order_search input {
	background:none;
	border:0 none;
	margin:0;
	padding:0;
	position:relative;
	z-index: 1;
	font-size:14px;
	color:#000;
	line-height:2;
	display:block;
	width:100%;
	outline:0;
}
.menber_control .order_search a {
	position:absolute;
	right:15px;
	top:50%;
	margin:-8px 0 0 0;
	font-size:16px;
	line-height:1;
	color:#000;
	z-index: 2;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.menber_control .order_search a:before {
	content:'\e690';
}
.menber_control .order_search a:hover {
	color:#62a8ea;
}
.menber_control .order_list {
	display:none;
	position:relative;
	min-height:400px;
}
.menber_control .order_list.active_bg {
	display:block;
}
.menber_control .order_list .no_order {
	font-size:20px;
	line-height:3;
	color:#ccc;
	text-align:center;
}
.menber_control .order_list>ul>li {
	border:1px solid #eee;
	padding:3px;
	overflow:hidden;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.menber_control .order_list>ul>li.move_bg {
	border-color:#f96868;
}
.menber_control .order_list>ul>li.m_receiving.move_bg {
	border-color:#62a8ea;
}
.menber_control .order_list .order_h {
	border-bottom:1px solid #eee;
	overflow:hidden;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.menber_control .order_list li.move_bg .order_h {
	border-bottom-color:#f96868;
}
.menber_control .order_list li.m_receiving.move_bg .order_h {
	border-bottom-color:#62a8ea;
}
.menber_control .order_list .order_title {
	font-size:22px;
	color:#f96868;
	line-height:2;
}
.menber_control .order_list .m_receiving .order_title {
	color:#62a8ea;
}
.menber_control .order_list .m_close .order_title {
	color:#999;
}
.menber_control .order_list .order_cont {
	font-size:14px;
	line-height:2;
	color:#666;
}
.menber_control .order_list .order_cont>span {
	padding:0;
}
.menber_control .order_h .text_right {
	text-align:right;
}
.menber_control .order_h .text_right .order_title {
	font-size:14px;
	color:#333;
}
.menber_control .order_h .text_right .order_cont {
	font-size:22px;
	line-height:2;
	color:#f96868;
}
.menber_control .m_receiving .order_h .text_right .order_cont {
	color:#62a8ea;
}
.menber_control .m_close .order_h .text_right .order_cont {
	color:#999;
}
.menber_control .order_list .order_b {
	overflow:hidden;
}
.menber_control .order_b .col-md-8 {
	/*display*/
	display:-webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	/*flex-direction*/
	-webkit-box-orient:horizontal;/*horizontal*/
	-webkit-box-direction:normal;/*reverse*/
	-moz-box-orient:horizontal;
	-moz-box-direction:normal;
	flex-direction:row;/*row*/
	-webkit-flex-direction:row;
	/*flex-wrap*/
	-webkit-flex-wrap:nowrap;/*nowrap*/
	-webkit-box-lines:multiple;/*single*/
	-moz-flex-wrap:nowrap;
	flex-wrap:nowrap;
	/*justify-content*/
	-webkit-justify-content:flex-start;
	justify-content:flex-start;/*主轴上对齐（横轴）*/
	-moz-box-pack:start;
	-webkit--moz-box-pack:start;
	box-pack:start;
	/*align-items*/
	align-items:flex-start;/*交叉轴对齐（垂直）*/
	-webkit-align-items:flex-start;
	box-align:start;
	-moz-box-align:start;
	-webkit-box-align:start;
}
.menber_control .order_b .order_info .text_h1 {
	color:#000;
	padding:0 0 0 10px;
}
.menber_control .order_b .order_info .text_h1 a {
	color:#999;
}
.menber_control .order_b .order_btn a {
	display:block;
	float:left;
	width:43%;
	margin:0 6% 0 0;
	_margin:0 3% 0 0;
	text-align:center;
	font-size:14px;
	line-height:2.5;
	color:#999;
	border:1px solid #eee;
	transition:all 0.3s ease 0s;
	-moz-transition:all 0.3s ease 0s;
	-webkit-transition:all 0.3s ease 0s;
	-o-transition:all 0.3s ease 0s;
}
.menber_control .order_b .order_btn a:hover {
	background:#eee;
}
.menber_control .order_b a.order_pay,
.menber_control .order_b a.order_pay:hover {
	background:#f96868;
	border-color:#f96868;
	color:#fff;
}
.menber_control .m_receiving .order_b a.order_pay,
.menber_control .m_receiving .order_b a.order_pay:hover {
	background:#62a8ea;
	border-color:#62a8ea;
	color:#fff;
}
.menber_control .m_close .order_b .order_btn a.order_detail {
	float:right;
}

/*订单详情*/
#menber_detail .order_list {
	min-height:inherit;
}
#menber_detail .order_list>ul>li {
	border:0 none;
}
#menber_detail .order_1 .text_h1 .m-b-5 {
	font-size:20px;
	line-height:2;
	position:relative;
	padding:0 0 0 50px;
}
#menber_detail .order_1 .text_h1 i {
	color:#f2a654;
	font-size:40px;
	line-height:1;
	padding:0 10px 0 0;
	position:absolute;
	top:50%;
	left:0;
	margin:-20px 0 0 0;
}
#menber_detail .order_1 .text_h1 i:before {
	content:"\e68c";
}
#menber_detail .order_1 .text_h1 p span {
	padding:0 5px;
	color:#f96868;
}
#menber_detail .order_b .order_info,
#menber_detail .order_b .order_info .text_h1,
#menber_detail .order_b .order_btn {
	padding:0;
}

#menber_detail .order_b .order_btn a {
	margin:0 0 0 6%;
	_margin:0 0 0 3%;
}
#menber_detail .order_2 ul {
	/*display*/
	display:-webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	/*flex-direction*/
	-webkit-box-orient:horizontal;/*horizontal*/
	-webkit-box-direction:normal;/*reverse*/
	-moz-box-orient:horizontal;
	-moz-box-direction:normal;
	flex-direction:row;/*row*/
	-webkit-flex-direction:row;
	/*flex-wrap*/
	-webkit-flex-wrap:nowrap;/*nowrap*/
	-webkit-box-lines:multiple;/*single*/
	-moz-flex-wrap:nowrap;
	flex-wrap:nowrap;
	/*justify-content*/
	-webkit-justify-content:center;
	justify-content:center;/*主轴上对齐（横轴）*/
	-moz-box-pack:center;
	-webkit--moz-box-pack:center;
	box-pack:center;
	/*align-items*/
	align-items:center;/*交叉轴对齐（垂直）*/
	-webkit-align-items:center;
	box-align:center;
	-moz-box-align:center;
	-webkit-box-align:center;
}
#menber_detail .order_2 ul li {
	padding:0;
	text-align:center;
	font-size:14px;
	line-height:2;
}
#menber_detail .order_2 .detail_icon {
	position:relative;
}
#menber_detail .order_2 .detail_icon span {
	display:block;
	width:50%;
	height:4px;
	position:absolute;
	top:50%;
	margin:-2px 0 0 0;
	z-index: 1;
	background:#f3f7f9;
}
#menber_detail .order_2 .detail_icon span.detail_line_left {
	left:0;
}
#menber_detail .order_2 .detail_icon span.detail_line_right {
	right:0;
}
#menber_detail .order_2 li.active_bg .detail_icon span {
	background:#62a8ea;
}
#menber_detail .order_2 .detail_icon i {
	display:block;
	margin:0 auto;
	width:50px;
	height:50px;
	line-height:50px;
	font-size:25px;
	text-align:center;
	color:#fff;
	background:#ccd5db;
	border:2px solid #ccd5db;
	-moz-border-radius: 25px;
    -khtml-border-radius: 25px;
    -webkit-border-radius: 25px;
    border-radius: 25px;
    -moz-border-radius-bottomleft: 25px;
    -moz-border-radius-bottomright: 25px;
    -khtml-border-radius: 25px;
    -webkit-border-bottom-left-radius: 25px;
    -webkit-border-bottom-right-radius:25px;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    position:relative;
    z-index: 2;
}
#menber_detail .order_2 li.active_bg .detail_icon i {
	background:#fff;
	border-color:#62a8ea;
	color:#62a8ea;
}
#menber_detail .order_2 .icon_1 .detail_icon i:before {
	content:"\e6ea";
}
#menber_detail .order_2 .icon_2 .detail_icon i:before {
	content:"\e68c";
}
#menber_detail .order_2 .icon_3 .detail_icon i:before {
	content:"\e632";
}
#menber_detail .order_2 .icon_4 .detail_icon i:before {
	content:"\e6e3";
}
#menber_detail .order_2 .detail_name,
#menber_detail .order_2 .detail_time {
	height:28px;
}
#menber_detail .order_3 .table-responsive {
	margin-bottom:0;
}
#menber_detail .order_3 table td {
	font-size:14px;
	line-height:1.2;
	color:#666;
}
#menber_detail .order_3 table td a {
	color:#62a8ea;
}
#menber_detail .order_3 .td_flex {
	/*display*/
	display:-webkit-box;
	display: -moz-box;
	display: -ms-flexbox;
	display: -webkit-flex;
	display: flex;
	/*flex-direction*/
	-webkit-box-orient:horizontal;/*horizontal*/
	-webkit-box-direction:normal;/*reverse*/
	-moz-box-orient:horizontal;
	-moz-box-direction:normal;
	flex-direction:row;/*row*/
	-webkit-flex-direction:row;
	/*flex-wrap*/
	-webkit-flex-wrap:nowrap;/*nowrap*/
	-webkit-box-lines:multiple;/*single*/
	-moz-flex-wrap:nowrap;
	flex-wrap:nowrap;
	/*justify-content*/
	-webkit-justify-content:flex-start;
	justify-content:flex-start;/*主轴上对齐（横轴）*/
	-moz-box-pack:center;
	-webkit--moz-box-pack:center;
	box-pack:center;
	/*align-items*/
	align-items:center;/*交叉轴对齐（垂直）*/
	-webkit-align-items:center;
	box-align:center;
	-moz-box-align:center;
	-webkit-box-align:center;
}
#menber_detail .order_3 .td_flex .text_h1 {
	padding:0 0 0 10px;
}
#menber_detail .order_4 ul {
	border-bottom:1px solid #eee;
}
#menber_detail .order_4 ul.ul_3 {
	border-bottom:0 none;
}
#menber_detail .order_4 ul li {
	font-size:14px;
	line-height:2;
}
#menber_detail .order_4 ul li strong {
	text-align:right;
	display:inline-block;
	width:104px;
	padding:0 5px 0 0;
}
#menber_detail .order_5 td {
	position:relative;
	font-size:14px;
	line-height:1;
	text-align:center;
	padding:15px 30px;
}
#menber_detail .order_5 td span {
	background:#e4eaec;
	padding:2px 5px;
}
#menber_detail .order_5 td i {
	font-style:normal;
	position:absolute;
	right:0;
	top:50%;
	margin:-7px 0 0 0;
}
/*弹窗确认*/
.BeAlert_box {
	box-shadow:0 0 5px #ccc;
}
/*手机端展示样式*/
@media (min-width: 320px) and (max-width:992px){
	.content1 .raduis-3 {
		overflow:visible;
	}
	.m-b-sm-15 {
		margin-bottom:15px;
	}
	.m-r-15 {
	    margin-right:0;
	}
	.m-l-15 {
	    margin-left:0;
	}
	.padding-30 {
		padding:15px;
	}
	.content1_padding {
	    padding: 0;
	}
	#menber_center .pay_data li {
		margin:0 10% 15px 10%;
		_margin:0 5% 15px 5%;
	}
	/*订单*/
	.menber_control .h_title li a {
		padding:15px 5px;
	}
	.menber_control .order_h .text_right {
		text-align:left;
	}
	.menber_control .order_b .order_btn a,
	#menber_detail .order_b .order_btn a {
		width:47%;
		margin:0;
		_margin:0;
	}
	.menber_control .order_b a.order_pay,
	.menber_control .order_b a.order_default {
		float:right;
	}
	#JH_width .menber_control .order_list .order_cont>span input {
		width:100%;
	}
	/*收货地址*/
	#menber_address .order_list .order_cont>span select {
		margin-bottom:15px;
	}
	#menber_address .order_1 .order_b .order_btn a {
		width:100%;
		margin-bottom:15px;
	}
	/*订单详情*/
	#menber_detail .order_5 td i {
		right:-6px;
	}
}
/*动画*/
@-webkit-keyframes slide-left {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@-o-keyframes slide-left {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue